// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3_WrU","content":"RecentSearches_content__3CJNc"};